module.exports = __webpack_public_path__ + "img/teacher-default.1e81fe36.png";